import {configureStore} from "@reduxjs/toolkit";
import { lobbyApi } from "store/services/lobby";
import { authenticationApi } from "store/services/authentication/authentication";
import loaderReducer from "store/features/loader/loaderSlice";
import planesReducer from "store/features/planes/planesSlice";

export const store = configureStore({
  reducer: {
    loader: loaderReducer,
    planes: planesReducer,
    [authenticationApi.reducerPath]: authenticationApi.reducer,
    [lobbyApi.reducerPath]: lobbyApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authenticationApi.middleware)
      .concat(lobbyApi.middleware)
});
